import { Store } from "vuex";

const state = {
  token: localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : '', // 当前登录的token
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '',
  menuIndex: localStorage.getItem('menuIndex') ? JSON.parse(localStorage.getItem('menuIndex')) : '',
  keepAliveList: [],
  idArr:[],
  sidArr:[],
  steady_idArr:[],
};
const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  menuIndex: state => state.menuIndex,
  idArr: state => state.idArr,
  sidArr: state => state.sidArr,
  steady_idArr: state => state.steady_idArr,
  keepAliveList: state => state.keepAliveList
};
const mutations = {
  setIdArr(state, data) {
    state.idArr = data;
  },
  setSidArr(state, data) {
    state.sidArr = data;
  },
  setSteady_idArr(state, data) {
    state.steady_idArr = data;
  },
  setToken(state, data) {
    localStorage.setItem('token', JSON.stringify(data));
    state.token = JSON.parse(localStorage.getItem('token'));
  },
  clearToken() {
    localStorage.removeItem('token');
  },
  setUser(state, data) {
    localStorage.setItem('userInfo', JSON.stringify(data));
    state.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  setMenu(state, data) {
    localStorage.setItem('menuIndex', JSON.stringify(data));
    state.menuIndex = JSON.parse(localStorage.getItem('menuIndex'));
  },
  pushKeepAliveList(state, item) {
    let set = new Set(state.keepAliveList);
    set.add(item);
    state.keepAliveList = Array.from(set);
  },
  popKeepAliveList(state, item) {
    let set = new Set(state.keepAliveList);
    if (set.has(item)) {
      set.delete(item);
    }
    state.keepAliveList = Array.from(set);
  }
};
const actions = {};

export default {
  state,
  getters,
  actions,
  mutations
};
